import { createSelector } from '@reduxjs/toolkit';
import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { PhaseEntityType } from 'data/projects/phase-entity';
import { logger } from 'services';
import { deleteSprintInProjectTemplate } from '../../actions';
import { selectTemplateSprint } from '../../selectors';
import { deleteProjectTemplateSprint, setProjectTemplateActiveRecord } from '../../slices';
const selectActiveRecord = createSelector((state)=>state.templates.project.activeRecord, (activeRecord)=>activeRecord);
function* deleteSprintInTemplateSaga(action) {
    try {
        const { payload: { sprintId } } = action;
        const sprint = yield select(selectTemplateSprint(sprintId));
        const activeRecord = yield select(selectActiveRecord);
        const shouldChangeActiveRecord = activeRecord && activeRecord.type === PhaseEntityType.Sprint ? sprint.sprintId === activeRecord.id : false;
        if (sprint.projectPhase) {
            yield put(deleteProjectTemplateSprint({
                sprintId
            }));
            if (shouldChangeActiveRecord) {
                yield put(setProjectTemplateActiveRecord({
                    id: sprint.projectPhase.projectPhaseId,
                    type: 'PROJECT_PHASE'
                }));
            }
        }
    } catch (error) {
        logger.error('deleteSprintInTemplateSaga failed ', {
            error
        });
        message.error('There was an error deleting the sprint');
    }
}
export function* watchDeleteSprintInProjectTemplateSaga() {
    yield takeLatest(deleteSprintInProjectTemplate.type, deleteSprintInTemplateSaga);
}
